import * as ko from "knockout";
import template from "./loading.html";
import Bao from "./../../services/bao-service";
export class LoadingAnimationService {
	/** this constant adds for x ms the "closing" class to the element, that creates an fading-out animation */
	public RemoveDuration = 250;
	public Visible = ko.pureComputed(() => {
		let returnValue: boolean = false;
		ko.utils.arrayForEach(this.registeredObservables(), (obs) => {
			if (obs()) {
				returnValue = true;
			}
		});
		return returnValue;
	}).extend({ rateLimit: { method: "notifyWhenChangesStop", timeout: 10 } });
	public Removing = ko.observable(false);

	private removeTimeout: any;
	private registeredObservables = ko.observableArray<KnockoutObservable<boolean>>([]);
	private subs: KnockoutSubscription[] = [];

	private clickCount = 0;
	private resetTimeoutRef = null;

	private appErrorHandler = () => {
		ko.utils.arrayForEach(this.registeredObservables(), (obs) => {
			obs(false); //resetting all loading observables
		});
	}

	constructor() {
		this.subs.push(this.Visible.subscribe((v) => {
			if (v == false && this.Removing() == false) {
				this.Removing(true);
				clearTimeout(this.removeTimeout);
				this.removeTimeout = setTimeout(() => {
					this.Removing(false);
				}, this.RemoveDuration);
			} else if (v == true) {
				this.Removing(false);
				clearTimeout(this.removeTimeout);
			}
		}));
		Bao.registerOnError(this.appErrorHandler);
	}
	public register(obs: KnockoutObservable<boolean>) {
		this.registeredObservables.push(obs);
	}
	public unregister(obs: KnockoutObservable<boolean>) {
		this.registeredObservables.remove(obs);
	}
	public dispose() {
		this.subs.forEach((s) => {
			s.dispose();
		});
	}
	public Clicker() {
		this.clickCount++;
		if (this.clickCount < 10) {
			this.resetTimeoutRef = setTimeout(() => {
				this.clickCount = 0;
			}, 5000);
		} else {
			this.clickCount = 0;
			clearTimeout(this.resetTimeoutRef);
			ko.utils.arrayForEach(this.registeredObservables(), (o) => {
				o(false);
			});
		}
	}

}
export const Loading = new LoadingAnimationService();
export default {
	viewModel: {
		instance: Loading
	},
	template: template
};
